<template>
    <div class="business-content-main" v-loading="loading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">扫码</div>
                <el-input
                    class="search-name"
                    ref="inputdata"
                    v-model="scanData"
                    clearable
                    placeholder="请扫描出库单码或商品标签"
                    size="small"
                    style="width: 250px"
                    @blur="inputblur()"
                    @change="inputDataChange()"
                ></el-input>
                <el-button size="small" class="search-btn btn-primary" :disabled="isForbidBatch && !isEnoughSubmit" @click="submit()">提交出仓</el-button>
                <el-button size="small" class="search-btn" type="primary" :disabled="cardList.length == 0" v-if="permission.tempSave" @click="tempSave()">{{
                    permission.tempSave
                }}</el-button>
                <div class="search-name" style="font-weight: bold" v-if="zoneName">仓库区域：{{ zoneName }}</div>
                <div class="search-name" v-if="orderCode">出库单号：{{ orderCode }}</div>
                <div class="search-name">拣货员</div>
                <el-select v-model="sId" class="search-item" filterable clearable remote size="small" placeholder="请选择">
                    <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                </el-select>
                <div class="search-name" style="color: red">（请先扫销售单，后扫商品标签。确保焦点在标签输入框内，并检查电脑的输入法是否英文输入）</div>
            </div>
        </div>
        <div>
            <el-row :gutter="20" class="table-ctn">
                <el-col :span="12">
                    <div class="grid-content">
                        <el-table
                            ref="goodsTable"
                            :header-cell-style="{ background: '#F2F6FC' }"
                            border=""
                            :data="dataList"
                            style="width: 100%"
                            empty-text="请扫描出库单上的二维码"
                            highlight-current-row
                            @cell-click="showLabelData"
                        >
                            <el-table-column label="汽配编码" show-overflow-tooltip min-width="100px" prop="APCode"></el-table-column>
                            <el-table-column label="汽配名称" show-overflow-tooltip min-width="100px" prop="GoodName"></el-table-column>
                            <el-table-column label="适用车型" show-overflow-tooltip min-width="100px" prop="AutoSerise"></el-table-column>
                            <el-table-column label="销售数量" show-overflow-tooltip width="80px" prop="Count"></el-table-column>
                            <el-table-column label="已出仓数" show-overflow-tooltip width="80px" prop="WarehousedCount"></el-table-column>
                            <el-table-column label="待出数量" show-overflow-tooltip width="80px">
                                <template slot-scope="scope">
                                    <div
                                        :class="{
                                            'check-class': scope.row.Count - scope.row.WarehousedCount > 0
                                        }"
                                    >
                                        {{ scope.row.Count - scope.row.WarehousedCount }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="扫码数量" show-overflow-tooltip width="80px">
                                <template slot-scope="scope">
                                    <div
                                        :class="{
                                            'check-class-enough': scope.row.Count - scope.row.WarehousedCount - scope.row.ScanCount == 0 && scope.row.ScanCount > 0
                                        }"
                                    >
                                        {{ scope.row.ScanCount }}
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="grid-content">
                        <div class="labelzone" v-infinite-scroll="bottomLoadHandle">
                            <template v-for="(item, index) in cardList">
                                <el-card :class="'box-card' + (item.IsFilter ? ' card-bg' : '')" :key="index" v-if="index < showLine" @click.native="showGoodsTB(item)">
                                    <div style="padding: 14px">
                                        <span class="goodname">{{ item.GoodName }}</span>
                                        <div class="bottom clearfix">
                                            <span class="apcode">{{ item.APCode }}</span>
                                            <span class="button">{{ item.PackingSpec + ' ' + item.Unit }}</span>
                                        </div>
                                        <div class="bottom clearfix">
                                            <time class="time">{{ item.LabelCode }}</time>
                                            <el-button type="text" class="button" icon="el-icon-delete" style="color: red" @click="delItem(item)"></el-button>
                                        </div>
                                    </div>
                                </el-card>
                            </template>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <audio ref="audio" controls hidden></audio>
        </div>
        <el-dialog :close-on-click-modal="false" title="选择出库单出库" @close="closeDialog" :visible.sync="orderListVisible" width="1200px">
            <div class="dialog-content" v-if="orderListVisible">
                <span style="color: red;"><i class="el-icon-warning-outline"></i>检测到当前销售单关联的多张出库单未出库，请选择需要出库的出库单</span>
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :row-style="{ height: '35px' }"
                    border=""
                    :data="orderList"
                    style="width: 100%"
                    highlight-current-row
                >
                    <el-table-column label="仓库区域" show-overflow-tooltip width="120px" prop="ZoneName"></el-table-column>
                    <el-table-column label="出库单据" show-overflow-tooltip prop="OrderWHCode"></el-table-column>
                    <el-table-column label="销售单号" show-overflow-tooltip prop="OrderCode"></el-table-column>
                    <el-table-column label="客户名称" show-overflow-tooltip prop="CusName"></el-table-column>
                    <el-table-column label="操作" show-overflow-tooltip width="100px">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button size="mini" type="text" @click="getDetail(scope.row.OrderId)">扫码出库</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
export default {
    name: 'OrderScan',
    components: {
        breadcrumb
    },
    data() {
        return {
            staffCodesConfig: false,
            loading: false,
            oid: '',
            sId: '',
            SIdList: [],
            dataList: [],
            scanData: '',
            labels: [],
            cardList: [],
            permission: {},
            zoneName: '',
            orderCode: '',
            orderListVisible:false,
            orderList:[],
            firstScanOrder: true,
            isAutoSubmit: false,
            isForbidBatch: false,
            isEnoughSubmit: false,
            currectAudio: '/download/currect.mp3',
            errorAudio: '/download/error.mp3',
            allOutAudio: '/download/allout.mp3',
            wrongXSAudio: '/download/wrongxs.mp3',
            repetLabel: '/download/repetlabel.mp3',
            enoughAudio: '/download/enough.mp3',
            delAudio: '/download/del.mp3',
            cancelAudio: '/download/cancel.mp3',
            autoSubmitAudio: '/download/autosubmit.mp3',
            recordPickerAudio: '/download/lrjhy.mp3',
            changePickerAudio: '/download/ggjhy.mp3',
            checkPickerAudio: '/download/checkpicker.mp3',
            submitSuccessAudio: '/download/submitsuccess.mp3',
            showLine: 25,
            rowSelectId: ''
        };
    },
    created() {
        this.getConfigByCodes();
    },
    mounted() {
        let that = this;
        that.permission = that.$util.getPermission('salesOrderTakeOut');
        that.oid = that.$route.query.oid;
        if (that.oid) that.getOrderDetail(0);
        that.getSIdList();
    },
    methods: {
        getConfigByCodes() {
            let codes = ['qzjhy', 'smzdtj', 'xzxsjkqbcc'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'qzjhy':
                                this.staffCodesConfig = result;
                                break;
                            case 'smzdtj':
                                this.isAutoSubmit = result;
                                break;
                            case 'xzxsjkqbcc': //限制分批出仓
                                this.isForbidBatch = result;
                                break;
                        }
                    }
                }
            });
        },
        getSaleOrderPickingPerson(orderCode) {
            let that = this;
            return new Promise((resolve, reject) => {
                that.$util
                    .axiosGet({
                        url: '/api/EntpSaleOrder/GetSaleOutOrderPickingPerson',
                        data: {
                            Order: orderCode,
                            Type: 1
                        }
                    })
                    .then(res => {
                        let data = res.data;
                        if (data) {
                            if (data.IsHavePicking) {
                                let i = this.SIdList.findIndex(item => {
                                    if (item.EmployeeId == data.EmployeeId) {
                                        return true;
                                    }
                                });
                                if (i == -1) {
                                    this.SIdList.push({
                                        EmployeeId: data.EmployeeId,
                                        EmployeeName: data.EmployeeName
                                    });
                                }
                                that.sId = data.EmployeeId;
                            }
                        }
                        resolve(data);
                    })
                    .catch(() => {});
            });
        },
        getOrderDetail(type) {
            let that = this;
            let order = type == 0 ? that.oid : that.orderCode;
            that.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetSaleOutOrderByScanData',
                    data: {
                        Order: order,
                        Type: type
                    }
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        that.$util.warningMsg(res.errmsg);
                        return;
                    }
                    if (data.IsDel) {
                        that.firstScanOrder = true;
                        that.aplayAudio(that.delAudio);
                        that.$util.warningMsg('提醒：销售出库单已被删除');
                        that.dataList = [];
                        that.oid = '';
                        return;
                    }
                    if (data.IsCancel) {
                        that.firstScanOrder = true;
                        that.aplayAudio(that.cancelAudio);
                        that.$util.warningMsg('提醒：销售出库单已被取消');
                        that.dataList = [];
                        that.oid = '';
                        return;
                    }
                    if (data.IsDelivery) {
                        that.firstScanOrder = true;
                        that.aplayAudio(that.allOutAudio);
                        that.$util.warningMsg('提醒：销售出库单商品已全部出仓');
                    } else {
                        if (type == 1) that.aplayAudio(that.currectAudio);
                    }
                    that.oid = data.OrderId;
                    that.orderCode = data.OrderCode;
                    that.zoneName = data.ZoneName;
                    let DetailList = data.DetailList;
                    that.labels = [];
                    that.cardList = [];
                    that.dataList = [];
                    for (let i = 0; i < DetailList.length; i++) {
                        that.dataList.push({
                            GoodsId: DetailList[i].EntpTempGoodsId,
                            APCode: DetailList[i].APCode,
                            GoodName: DetailList[i].GoodName,
                            Unit: DetailList[i].Unit,
                            AutoSerise: DetailList[i].AutoSerise,
                            Count: DetailList[i].Count,
                            WarehousedCount: DetailList[i].WarehousedCount,
                            ScanCount: 0,
                            SortField: 0
                        });
                    }
                    if (data.IsHaveTempLabels) {
                        that.$confirm('检测到该单存在临时标签数据，需要加载吗？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '不加载',
                            type: 'warning',
                            center: false
                        }).then(() => {
                            that.getTempLabels();
                        });
                    }
                })
                .catch(() => {});
        },
        closeDialog(){
            this.orderListVisible = false;
        },
        getOrderWHList() {
            let that = this;
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetSaleWHOrderList',
                    data: {
                        OrderCode: that.scanData,
                    },
                    hideLoading: false
                })
                .then(res => {
                    that.scanData = "";
                    if (res.data) {
                        if(res.data.length == 1){
                            that.oid = res.data[0].OrderId;
                            that.labels = [];
                            that.cardList = [];
                            that.getOrderDetail(0);
                        }else{
                            that.orderList = res.data;
                            that.orderListVisible = true;
                            
                        }
                    }else{
                        if(res.errcode == 200){
                            that.$util.warningMsg(res.errmsg);
                            return;
                        }
                        that.$util.errorMsg(res.errmsg);
                        return;
                    }
                })
                .catch(() => {
                    that.loading = false;
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        getDetail(Id){
            let that = this;
            that.oid = Id;
            that.labels = [];
            that.cardList = [];
            that.orderListVisible = false;
            that.getOrderDetail(0);
        },
        // 失去焦点
        inputblur() {
            let that = this;
            // FireFox 和 IE 失去焦点，blur直接执行focus 不会生效，加个延时
            setTimeout(() => {
                if (that.$refs.inputdata) that.$refs.inputdata.focus();
            }, 100);
        },
        inputDataChange() {
            let that = this;
            if(that.scanData.length >= 17 && that.scanData.length <= 20 && that.scanData.startsWith('XS')){
                if (!that.oid) {
                    that.getOrderWHList();
                } else {
                    that.$confirm('检测到其他订单，是否需要切换？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: false
                    })
                        .then(() => {
                            that.getOrderWHList();
                        })
                        .catch(() => {
                            that.scanData = '';
                        });
                    }
            }else{
                if (that.scanData.indexOf('AP-') > -1) {
                    if (that.staffCodesConfig) {
                        if (!that.sId) {
                            that.aplayAudio(that.checkPickerAudio);
                            that.$util.warningMsg('请先扫拣货员二维码或选择拣货员');
                            that.scanData = '';
                            return;
                        }
                    }
                    if (that.scanData.length == 20) {
                        that.$util
                            .axiosGet({
                                url: '/api/EntpSaleOrder/CheckEntpSaleOutOrderGoods',
                                data: {
                                    SaleWHOutOrderId: that.oid,
                                    LabelCode: that.scanData
                                }
                            })
                            .then(res => {
                                let data = res.data;
                                if (data) {
                                    let datalist = that.dataList;
                                    let scount = 0;
                                    let needCount = 0;
                                    let isFilter = !that.rowSelectId ? false : that.rowSelectId == data.GoodsId;
                                    var label = {
                                        APCode: data.APCode,
                                        GoodName: data.GoodName,
                                        PackingSpec: data.PackingSpec,
                                        LabelCode: data.LabelCode,
                                        Unit: data.Unit,
                                        LabelId: data.LabelId,
                                        GoodsId: data.GoodsId,
                                        IsFilter: isFilter
                                    };
                                    var isRepet = false;
                                    if (that.cardList.length > 0) {
                                        that.cardList.forEach(element => {
                                            if (element.LabelCode == label.LabelCode) {
                                                isRepet = true;
                                                that.$util.warningMsg('重复标签！');
                                                return;
                                            }
                                        });
                                    }
                                    if (isRepet) {
                                        that.aplayAudio(that.repetLabel);
                                        return;
                                    }
    
                                    if (datalist && datalist.length > 0) {
                                        that.isEnoughSubmit = true;
                                        for (let i = 0; i < datalist.length; i++) {
                                            if (datalist[i].GoodsId == label.GoodsId) {
                                                scount = datalist[i].ScanCount;
                                                needCount = datalist[i].Count - datalist[i].WarehousedCount;
    
                                                if (scount + label.PackingSpec <= needCount) {
                                                    datalist[i].ScanCount += label.PackingSpec;
                                                    that.cardList.push(label);
                                                    that.labels.push(data.LabelId);
                                                } else {
                                                    that.aplayAudio(that.enoughAudio);
                                                    that.$util.warningMsg('标签的商品总数大于销售待出的数量！');
                                                    return;
                                                }
                                                datalist[i].SortField =
                                                    datalist[i].Count - datalist[i].WarehousedCount - datalist[i].ScanCount == 0 && datalist[i].ScanCount > 0 ? 1 : 0;
                                            }
    
                                            if (datalist[i].Count - datalist[i].WarehousedCount != datalist[i].ScanCount) that.isEnoughSubmit = false;
                                        }
                                        datalist.sort(function (a, b) {
                                            return a.SortField - b.SortField;
                                        });
    
                                        //判断是否已经完成了销售单的标签已经扫够，如果刚好够的话，自动提交
                                        if (that.isAutoSubmit) {
                                            if (that.isEnoughSubmit) that.submit();
                                            else that.aplayAudio(that.currectAudio);
                                        } else that.aplayAudio(that.currectAudio);
                                    }
                                } else {
                                    that.aplayAudio(that.errorAudio);
                                }
                            })
                            .catch(() => {
                                that.aplayAudio(that.errorAudio);
                            });
                    } else if (that.scanData.length != 0) {
                        that.aplayAudio(that.errorAudio);
                        that.$util.warningMsg('标签码长度不符合规则！');
                    }
                } else if (that.scanData.length === 36) {
                    let staffId = that.scanData;
                    if (that.sId) {
                        that.$confirm('确定要切换拣货员吗？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning',
                            center: false
                        })
                            .then(() => {
                                that.aplayAudio(that.changePickerAudio);
                                that.sId = staffId;
                            })
                            .catch(() => {});
                    } else {
                        that.aplayAudio(that.recordPickerAudio);
                        that.sId = staffId;
                    }
                } else {
                    let orderCode = that.scanData;
                    if (that.staffCodesConfig) {
                        that.getSaleOrderPickingPerson(orderCode).then(data => {
                            if (!that.sId) {
                                that.aplayAudio(that.checkPickerAudio);
                                that.$util.warningMsg('请先扫拣货员二维码或选择拣货员');
                                that.scanData = '';
                                return;
                            } else {
                                that.scanOrder(orderCode);
                            }
                        });
                    } else {
                        that.scanOrder(orderCode);
                    }
                }
                that.scanData = '';
            }
        },
        scanOrder(scanData) {
            let that = this;
            that.orderCode = scanData;
            if (that.firstScanOrder) {
                that.firstScanOrder = false;
                that.getOrderDetail(1);
            } else {
                that.$confirm('已经有未提交出仓销售单，是否确定放弃提交？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.labels = [];
                        that.cardList = [];
                        that.dataList = [];
                        that.oid = '';
                        this.getOrderDetail(1);
                    })
                    .catch(() => {});
            }
        },
        delItem(item) {
            let that = this;
            if (item) {
                this.cardList.splice(this.cardList.indexOf(item), 1);
                this.labels.splice(this.labels.indexOf(item.LabelId), 1);
                let datalist = that.dataList;
                if (datalist && datalist.length > 0) {
                    for (let i = 0; i < datalist.length; i++) {
                        if (datalist[i].GoodsId == item.GoodsId) {
                            if (datalist[i].ScanCount > 0) datalist[i].ScanCount -= item.PackingSpec;
                            datalist[i].SortField = datalist[i].Count - datalist[i].WarehousedCount - datalist[i].ScanCount == 0 && datalist[i].ScanCount > 0 ? 1 : 0;
                            datalist.sort(function (a, b) {
                                return a.SortField - b.SortField;
                            });
                            that.dataList = datalist;
                            return;
                        }
                    }
                }
            }
        },
        submit() {
            let that = this;
            if (that.labels.length == 0) {
                that.$util.warningMsg('无标签信息，请重新扫码');
                return;
            }
            if (that.isAutoSubmit) {
                that.loading = true;
                that.$util
                    .axiosPost({
                        url: '/api/EntpSaleOrder/EntpScanLabelOutStorage_OutOrder',
                        data: {
                            StaffId: that.sId,
                            SaleOrderId: that.oid,
                            LabelIdList: that.labels
                        }
                    })
                    .then(res => {
                        if (res.data) {
                            if (res.data && res.data.length > 0) {
                                that.$util.errorMsg(res.errmsg);
                                that.aplayAudio(that.errorAudio);
                                for (let i = 0; i < that.cardList.length; i++) {
                                    let gIdx = res.data.findIndex(f => f === that.cardList[i].GoodsId);
                                    if (gIdx == -1) {
                                        that.cardList.splice(i, 1);
                                        that.labels.splice(that.labels.indexOf(that.cardList[i].LabelId), 1);
                                    }
                                }
                                that.getOrderDetail(0);
                            } else {
                                that.$util.successMsg('已成功自动出仓');
                                that.labels = [];
                                that.cardList = [];
                                that.sId = '';
                                that.firstScanOrder = true;
                                that.getOrderDetail(0);
                            }
                        } else {
                            that.$util.successMsg('已成功自动出仓');
                            that.labels = [];
                            that.cardList = [];
                            that.sId = '';
                            that.firstScanOrder = true;
                            that.getOrderDetail(0);
                        }
                        that.loading = false;
                    })
                    .catch(() => {
                        that.loading = false;
                    });
            } else {
                that.$confirm('确定提交出仓吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                }).then(() => {
                    this.loading = true;
                    this.$util
                        .axiosPost({
                            url: '/api/EntpSaleOrder/EntpScanLabelOutStorage_OutOrder',
                            data: {
                                StaffId: that.sId,
                                SaleOrderId: that.oid,
                                LabelIdList: that.labels
                            }
                        })
                        .then(res => {
                            if (res.data) {
                                if (res.data && res.data.length > 0) {
                                    that.$util.errorMsg(res.errmsg);
                                    that.aplayAudio(that.errorAudio);
                                    for (let i = 0; i < that.cardList.length; i++) {
                                        let gIdx = res.data.findIndex(f => f === that.cardList[i].GoodsId);
                                        if (gIdx == -1) {
                                            that.cardList.splice(i, 1);
                                            that.labels.splice(that.labels.indexOf(that.cardList[i].LabelId), 1);
                                        }
                                    }
                                } else {
                                    that.$util.successMsg('出仓成功');
                                    that.aplayAudio(that.submitSuccessAudio);
                                    that.labels = [];
                                    that.cardList = [];
                                    that.sId = '';
                                    that.firstScanOrder = true;
                                }
                            } else {
                                that.$util.successMsg('出仓成功');
                                that.aplayAudio(that.submitSuccessAudio);
                                that.labels = [];
                                that.cardList = [];
                                that.sId = '';
                                that.firstScanOrder = true;
                            }
                            that.getOrderDetail(0);
                            that.loading = false;
                        })
                        .catch(() => {
                            that.loading = false;
                        });
                });
            }
        },
        aplayAudio(audioUrl) {
            this.$refs.audio.src = audioUrl;
            this.$nextTick(res => {
                this.$refs.audio.load();
                this.$refs.audio.play();
            });
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        tempSave() {
            let that = this;
            if (that.labels.length == 0) {
                that.$util.warningMsg('无标签信息，请重新扫码');
                return;
            }
            that.$confirm('确定要临时保存标签数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: false
            }).then(() => {
                that.loading = true;
                this.$util
                    .axiosPost({
                        url: '/api/EntpGoodsLabels/SaveOutWhOrderLabelToTemp',
                        data: {
                            OrderCode: that.orderCode,
                            LabelIdList: that.labels
                        }
                    })
                    .then(res => {
                        that.$util.successMsg('成功保存临时数据');
                        that.loading = false;
                    })
                    .catch(() => {
                        that.loading = false;
                    });
            });
        },
        getTempLabels() {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpGoodsLabels/GetTempLabelCodes',
                    data: {
                        OrderCode: that.orderCode
                    }
                })
                .then(res => {
                    let list = res.data;
                    let datalist = that.dataList;
                    if (list.length > 0) {
                        let isHErrData = false;
                        let errStr = '已过滤异常状态的标签';
                        for (let index = 0; index < list.length; index++) {
                            let data = list[index];
                            if (data.State == 0) {
                                let scount = 0;
                                let needCount = 0;
                                var label = {
                                    APCode: data.APCode,
                                    GoodName: data.GoodName,
                                    PackingSpec: data.PackingSpec,
                                    LabelCode: data.LabelCode,
                                    Unit: data.Unit,
                                    LabelId: data.LabelId,
                                    GoodsId: data.GoodsId,
                                    IsFilter: false
                                };

                                if (datalist && datalist.length > 0) {
                                    that.isEnoughSubmit = true;
                                    let isBey = false;
                                    for (let i = 0; i < datalist.length; i++) {
                                        if (datalist[i].GoodsId == label.GoodsId) {
                                            scount = datalist[i].ScanCount;
                                            needCount = datalist[i].Count - datalist[i].WarehousedCount;

                                            if (scount + label.PackingSpec > needCount) {
                                                isBey = false;
                                            }

                                            datalist[i].ScanCount += label.PackingSpec;
                                            that.cardList.unshift(label);
                                            that.labels.unshift(data.LabelId);
                                        }
                                        if (datalist[i].Count - datalist[i].WarehousedCount != datalist[i].ScanCount) that.isEnoughSubmit = false;
                                    }
                                    if (isBey) {
                                        that.aplayAudio(that.enoughAudio);
                                        that.$util.warningMsg('标签的商品总数大于销售待出的数量！');
                                    }
                                    that.dataList = datalist;
                                }
                            } else {
                                isHErrData = true;
                                errStr += '【' + data.LabelCode + '】';
                            }
                        }

                        if (isHErrData) that.$util.errorMsg(errStr);
                    }
                });

            that.$refs.goodsTable.setCurrentRow();
        },
        // 触底加载
        bottomLoadHandle() {
            let listLen = this.cardList.length;
            if (listLen > this.showLine + 25) {
                this.showLine += 25;
            } else {
                this.showLine = listLen;
            }
        },
        showLabelData(item, column) {
            let that = this;
            if (
                (!that.rowSelectId || that.rowSelectId.length == 0 || (that.rowSelectId && that.rowSelectId != item.GoodsId)) &&
                that.cardList &&
                that.cardList.length > 0
            ) {
                that.cardList.forEach(f => {
                    if (f.GoodsId === item.GoodsId) f.IsFilter = true;
                    else f.IsFilter = false;
                });
                that.rowSelectId = item.GoodsId;
            } else {
                that.cardList.forEach(f => {
                    f.IsFilter = false;
                });
                that.rowSelectId = '';
                that.$refs.goodsTable.setCurrentRow();
            }
        },
        showGoodsTB(item) {
            let that = this;
            for (let index = 0; index < that.dataList.length; index++) {
                const element = that.dataList[index];
                if (element.GoodsId == item.GoodsId) {
                    that.$refs.goodsTable.setCurrentRow(element);
                    that.showLabelData(element);
                    return;
                }
            }
        }
    }
};
</script>
<style lang="less" scoped>
.dialog-content{
    /deep/ .el-table td, .el-table th{
        padding: 0 !important;
    }
}
.labelzone {
    display: flex;
    justify-content: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    padding-left: 20px;
    width: 100%;
    height: 100%;
    margin-bottom: 30px;
    overflow-y: scroll;
    height: calc(100vh - 300px);
}
.labelk {
    display: flex;
    flex-direction: column;
}
.box-card {
    width: 220px;
    margin: 5px;
}

.card-bg {
    background-color: rgb(184, 226, 250);
}

.time {
    font-size: 13px;
    color: #999;
}

.bottom {
    margin-top: 13px;
    line-height: 12px;
}

.button {
    padding: 0;
    float: right;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: '';
}

.clearfix:after {
    clear: both;
}

.goodname {
    font-size: 18px;
    line-height: 24px;
}
.apcode {
    font-size: 15px;
}
.check-class {
    color: red;
    font-weight: bold;
}
.check-class-enough {
    color: green;
    font-weight: bold;
}
</style>
